import { useState, useEffect ,useRef} from "react";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import { fetchRelatedCoupons, applyCouponAPI } from "../../Providers/couponsProvider";
import { useDispatch,useSelector } from "react-redux";
import { fetchCartItems } from "../../Providers/cartProvider";

const backgroundColors = ["bg-tertiary", "bg-tertiary", "bg-tertiary"];

export default function CouponPopup({ onClose, onSelectCoupon }) {
  const dispatch = useDispatch();
  const cartItems = useSelector((state) => state.cartItems); // Access state
  const [expandedCoupon, setExpandedCoupon] = useState(null);
  const [selectedCoupon, setSelectedCoupon] = useState(null);
  const [relatedCoupons, setRelatedCoupons] = useState([]);
  const [moreCoupons, setMoreCoupons] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [isApplying, setIsApplying] = useState(false);


  

  useEffect(() => {
    document.body.classList.add("overflow-hidden");
    return () => {
      document.body.classList.remove("overflow-hidden");
    };
  }, []);

  useEffect(() => {
    const getCoupons = async () => {
      setLoading(true);
      setError("");
      try {
        const { data } = await fetchRelatedCoupons();
        if (data) {
          setRelatedCoupons(
            data.feasibleCoupons.map((coupon, index) => ({
              id: coupon.id,
              background: backgroundColors[index % backgroundColors.length],
              discount:
                coupon.discount_type === "percentage"
                  ? `${coupon.discount}% Off`
                  : `₹ ${coupon.discount} Off`,
              description: coupon.description,
              code: coupon.code,
              savings: coupon.max_discount || 0,
              minOrder: coupon.min_order_value || 0,
              validTill: coupon.valid_until || null,
            }))
          );
          setMoreCoupons(
            data.nonFeasibleCoupons.map((coupon, index) => ({
              id: coupon.id,
              background: backgroundColors[index % backgroundColors.length],
              discount:
                coupon.discount_type === "percentage"
                  ? `${coupon.discount}% Off`
                  : `₹ ${coupon.discount} Off`,
              description: coupon.description,
              code: coupon.code,
              savings: coupon.max_discount || 0,
              minOrder: coupon.min_order_value || 0,
              validTill: coupon.valid_until || null,
            }))
          );
        }
      } catch (err) {
        setError("Failed to fetch coupons. Please try again.");
      }
      setLoading(false);
    };
  
    getCoupons();
  }, []);

  useEffect(() => {
    if (!selectedCoupon) return;

    const applyCoupon = async () => {
      
      setIsApplying(true);
      setError("");

      try {
        const response = await applyCouponAPI(selectedCoupon.code);
        if (response.data) {
          console.log("Coupon applied successfully:", response.data);
          
          onClose();
          dispatch(fetchCartItems());
        } else {
          setError(response.error || "Failed to apply coupon.");
        }
      } catch (err) {
        setError("Error applying coupon. Please try again.");
      }

      setIsApplying(false);
    };

    applyCoupon();
    
  }, [selectedCoupon]);
 

  const renderCoupons = (coupons, isMoreCoupons = false) =>
    coupons.length > 0 ? (
      coupons.map((coupon) => (
        <div
          key={coupon.id}
          className={`border border-hcolor p-3 mb-2 rounded ${coupon.background} ${
            isMoreCoupons ? "opacity-50" : ""
          }`}
        >
          <div
            className="flex justify-between items-center cursor-pointer"
            onClick={() =>
              setExpandedCoupon(expandedCoupon === coupon.id ? null : coupon.id)
            }
          >
            <p className="font-medium">{coupon.description}</p>
            {expandedCoupon === coupon.id ? <FaChevronUp /> : <FaChevronDown />}
          </div>
          {expandedCoupon === coupon.id && (
            <div className="mt-2 text-sm text-gray-600">
              <p className="text-hcolor font-poppins text-base">
                <strong>Code: {coupon.code}</strong>
              </p>
              <p>Discount: {coupon.discount}</p>
              <p className="text-green-600">Max Savings: ₹{coupon.savings}</p>
              <p className="text-hcolor">Min Order Value: ₹{coupon.minOrder}</p>
              {/* <p className="text-hcolor">
                Valid Till:{" "}
                {coupon.validTill
                  ? new Date(coupon.validTill).toLocaleDateString("en-GB", {
                      day: "numeric",
                      month: "long",
                      year: "numeric",
                    })
                  : "Not Available"}
              </p> */}
              <button
                className={`mt-2 p-1 rounded w-full ${
                  isMoreCoupons
                    ? "bg-secondary cursor-not-allowed text-gray-500"
                    : "bg-hcolor text-tertiary hover:bg-tertiary hover:text-hcolor font-poppins border border-hcolor"
                }`}
                disabled={isMoreCoupons || isApplying}
                onClick={() => !isMoreCoupons && setSelectedCoupon(coupon)}
              >
                {isApplying ? "Applying..." : "Select Coupon"}
              </button>
            </div>
          )}
        </div>
      ))
    ) : (
      <p className="text-hcolor">No coupons available</p>
    );

    const popupRef = useRef(null);
  
    useEffect(() => {
      // Function to handle click outside
      const handleClickOutside = (event) => {
        if (popupRef.current && !popupRef.current.contains(event.target)) {
          onClose(); // Close the popup
        }
      };
  
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [onClose]);
  return (
    <div className="fixed inset-0 backdrop-blur-sm  z-50 flex justify-center items-center">
      
      <div className="bg-tertiary w-96 p-5 rounded-lg shadow-lg max-h-[90vh] overflow-auto " ref={popupRef}>
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-primary1 font-outfit font-normal text-2xl ">Apply Coupon</h2>
         
          <button onClick={onClose} className="text-xl">&times;</button>
        </div>

        {loading ? (
          <p className="text-primary1">Loading coupons...</p>
        ) : error ? (
          <p className="text-hcolor">{error}</p>
        ) : (
          <>
            <h3 className="text-primary1 font-outfit font-light text-xl mt-4">Related Coupons</h3>
            {renderCoupons(relatedCoupons, false)}

            <hr className="my-4 border-secondary" />

            <h3 className="text-primary1 font-outfit font-light text-xl mt-4">More Coupons</h3>
            {renderCoupons(moreCoupons, true)}
          </>
        )}
      </div>
    </div>
  );
}
